import { render, staticRenderFns } from "./addNewPaymentModel.vue?vue&type=template&id=3f28c83c&"
import script from "./addNewPaymentModel.vue?vue&type=script&lang=js&"
export * from "./addNewPaymentModel.vue?vue&type=script&lang=js&"
import style0 from "./addNewPaymentModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports